import { Spinner } from "@nextui-org/react";

import BannedBanner from "@/components/BannedBanner";
import useAutoLangugeSelect from "@/hooks/useAutoLangugeSelect";
import useLocalizationGate from "@/hooks/useLocalizationGate";

const Banned = ({ banType = "" }) => {
  useAutoLangugeSelect();
  const { isLocalizationReady } = useLocalizationGate();

  if (!isLocalizationReady) {
    return <Spinner className="h-full" />;
  }

  return (
    <>
      <BannedBanner banType={banType} />
    </>
  );
};

export default Banned;
